const severity = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}[,.]\d+\s+\[[^\]\r\n]+\]\s+\[[^\]\r\n]+\]\s+(NOTICE|INFO|WARN|ERROR|FATAL)\s+-/;

/**
 * Severity of a log line, read off its severity field and never off a severity word inside the message.
 *
 * @param {string} line One line of an MSP360 log.
 * @return {string} The severity in lower case, or an empty string when the line carries none.
 */
export function msp360LogLevel(line: string): string {
  return severity.exec(line)?.[1].toLowerCase() || '';
}
